'use strict'

/*
    WEBSITE TRAVELER REDESIGN
    created on: 26/02/2024
    Author: ISC. Oswaldo Álvarez Juárez
    Email: oswaldo.aj29@outlook.com

*/
let slcService = document.querySelector('#slctModalInoviceOutService');
let slcServiceType = document.querySelector('#slctModalInvoiceOutServiceType');
let txtFolio = document.querySelector('#txtModalInvoiceOutFolio');


let btnEnviarBuyOut = document.querySelector('#sendDataInfo'); //cuando se factura por ser compra fuera de la plataforma
let btnEnviarBuyOnline = document.querySelector('#sendDataInfoBuyOnline') //cuando se factura por compra online
let arrayInputs = document.querySelectorAll('[data-requerido="true"]');
let arrayErrors = [];
let regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


$(document).ready(function(){
    StartEvents();
});

//FUNCTION THAT ENABLE THE EVENTS
function StartEvents(){
    slcService.addEventListener('change', activeServiceControl);
    btnEnviarBuyOut.addEventListener('click', sendDataInvoice);
    btnEnviarBuyOnline.addEventListener('click', sendDataInvoice);
}



////////////////////////////////////////////////////////////////
//// FUNCTIONS
//////////////////////////////////////////////////////////////
/**
 * Author: Oswaldo álvarez juárez
 * Email: oswaldo.aj29@outlook.com
 * @param {*DOM} event dom del evento
 * Description: nos ayuda a activar o desactivar otros campos en base al select de servicio
 */
function activeServiceControl(event){
    
    if(event.target.value === 'Servicios de viaje' ){
        slcServiceType.disabled = false;
        txtFolio.disabled = false;
        slcServiceType.setAttribute("required", "required");
        slcServiceType.setAttribute("data-requerido", "true");

        txtFolio.setAttribute("required", "required");
        txtFolio.setAttribute("data-requerido", "true");

    }
    else if(event.target.value === 'Pago de membresía/anualidad'){
        slcServiceType.disabled = true;
        txtFolio.disabled = true;
        slcServiceType.removeAttribute("required");
        slcServiceType.setAttribute("data-requerido", "false");

        txtFolio.removeAttribute("required");
        txtFolio.setAttribute("data-requerido", "false");
    }
    else{
        slcServiceType.disabled = true;
        txtFolio.disabled = true;
        slcServiceType.removeAttribute("required");
        slcServiceType.setAttribute("data-requerido", "false");

        txtFolio.removeAttribute("required");
        txtFolio.setAttribute("data-requerido", "false");
    }
}

/**
 * Author: Oswaldo álvarez juárez
 * Email: oswaldo.aj29@outlook.com
 * @param {*String} id id del botón que se presionó
 * Description: nos ayuda a validar si existe algún error con algún campo mal o no completado
 */
function withoutErrors(id){
    arrayErrors = [];
    let arrayInputs = [];
    let divMessages = null;
    if(id.toString() === 'sendDataInfo'){ //cuando es factura fuera de la plataforma
        arrayInputs = document.querySelectorAll('#invoiceOutWeb [data-requerido="true"]');
        divMessages = document.querySelector('#messagesBuyOut');
    }
    else{ //cuando es factura por pago en linea a traves de la plataforma
        arrayInputs = document.querySelectorAll('#invoiceOnlineWeb [data-requerido="true"]');
        divMessages = document.querySelector('#messagesBuyOnline');
    }
    arrayInputs.forEach(function(item, index){
        if (item.type === 'email' && !regexEmail.test(item.value) && item.value !== '') {
            arrayErrors.push(`${item.previousElementSibling.previousElementSibling.textContent.slice(0, -1)} no es correcto y`);
          }
          else if (item.value === '' || item.value == '0') {
            arrayErrors.push(item.previousElementSibling.previousElementSibling.textContent.slice(0, -1));
          }
    });

    if (!arrayErrors.length) { //no tiene errores
        // formulario.submit();
        return true;
    } 
    else { //tiene errores
        if (divMessages.innerHTML === '') 
        {
          arrayErrors.forEach(function (item) {
            const msError = document.createElement('div');
            msError.classList.add('alert', 'alert-danger');
            msError.style.fontSize = '12px';
            msError.style.fontWeight = 'bold';
            msError.textContent = `El campo ${item} es obligatorio`;
            divMessages.appendChild(msError);
          });
    
          setTimeout(() => {
            divMessages.innerHTML = '';
            // divMessages.classList.remove('alert-danger');
          }, 5000);
        }

        return false;
    }


}

/**
 * Author: Oswaldo álvarez juárez
 * Email: oswaldo.aj29@outlook.com
 * @param {*DOM} event dom del evento
 * Description: hace el envio de los datos mediante fetch js una vez que se hayan validado los datos
 */
function sendDataInvoice(event){
    event.preventDefault();
    let form = '';
    let link = '';
    let spinerLoading = null;
    let divMessages = null;
    if(event.target.id === 'sendDataInfo'){
        form = document.querySelector('#invoiceOutWeb');
        link = $(form).attr('action');
        spinerLoading = document.querySelector('#form-invoice-message-buyOut');
        divMessages = document.querySelector('#messagesBuyOut');
    }
    else{
        form = document.querySelector('#invoiceOnlineWeb');
        link = $(form).attr('action');
        spinerLoading = document.querySelector('#form-invoice-message-buyOnline');
        divMessages = document.querySelector('#messagesBuyOnline');
    }

    let formData = new FormData(form);

    if( withoutErrors(event.target.id) ){

        //loading...
        spinerLoading.innerHTML = '<div class="sk-chase"><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div>'+
        '<div class="sk-chase-dot"></div><div class="sk-chase-dot"></div><div class="sk-chase-dot"></div></div>';

        fetch(link, {
            method: "POST",
            body: formData
        })

        .then(function(response) {
            spinerLoading.innerHTML = '';
            if (response.ok) {
                return response.json(); // Aquí conviertes la respuesta a JSON
            
            } else {
                throw new Error();
            }
        })

        .then(function(data){
            if(data.status === 'success'){ 
                divMessages.classList.add('alert', 'alert-success');
                divMessages.innerHTML = data.messages;
                form.reset(); // Limpiar formulario si la solicitud fue exitosa
            }
            else{
                divMessages.classList.add('alert', 'alert-danger');
                divMessages.innerHTML = data.messages;
            }

            setTimeout(()=>{
               divMessages.innerHTML = '';
               divMessages.className = '';
            }, 3500);
        })

        .catch(function(error) {
            spinerLoading.innerHTML = '';
            divMessages.innerHTML = 'Ha ocurrido un error al enviar los datos.';
        });


    }

}